import { render, staticRenderFns } from "./AddressNew.vue?vue&type=template&id=2f45164f&scoped=true"
import script from "./AddressNew.vue?vue&type=script&lang=ts"
export * from "./AddressNew.vue?vue&type=script&lang=ts"
import style0 from "./AddressNew.vue?vue&type=style&index=0&id=2f45164f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45164f",
  null
  
)

export default component.exports